import React, { useState } from 'react';
import Cookies from 'universal-cookie';
import useInterval from './use_interval';
import moment from 'moment';

const LOCALE_MAP = {
  'en-GB': 'en-gb',
  zh: 'zh-cn'
};

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
const cookies = new Cookies();

const RelativeDatetime = props => {
  const { timestamp } = props;
  const selectedLanguage = cookies.get('preferred_lang') || 'en';
  const locale = LOCALE_MAP[selectedLanguage] || selectedLanguage;
  const m = moment;

  m.relativeTimeThreshold('s', 55);
  m.relativeTimeThreshold('ss', 5);

  const calculateRelativeTime = () =>
    capitalize(
      m(timestamp)
        .locale(locale)
        .parseZone()
        .fromNow()
    );
  const [relativeTime, setRelativeTime] = useState(calculateRelativeTime());

  useInterval(() => {
    setRelativeTime(calculateRelativeTime());
  }, 60000);

  return <span>{relativeTime}</span>;
};

export default RelativeDatetime;



// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/relative_datetime.jsx